import { render } from "./ChevronUp.vue?vue&type=template&id=2711cacb&ts=true"
import script from "./ChevronUp.vue?vue&type=script&lang=ts"
export * from "./ChevronUp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__